// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.associadosEngMain {
    flex: 1 1;
    display: flex;
    width: calc(100% - 40px);
    flex-direction: column;
    padding-left: 45px;
}`, "",{"version":3,"sources":["webpack://./src/pages/AssociadosEng/associadosEng.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,aAAa;IACb,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;AACtB","sourcesContent":[".associadosEngMain {\n    flex: 1;\n    display: flex;\n    width: calc(100% - 40px);\n    flex-direction: column;\n    padding-left: 45px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
